import RequestError from "@/types/utils/RequestError";
import Apm from "@/utils/Apm";
import axios from "axios";

const api = axios.create({
    baseURL: 'https://api.estadao.com.br'
})

export const generateCookie = async (): Promise<void> => {
    api.get('/users/me?with_cookie=1&set_cookies=1', {
        withCredentials: true
    }).catch((err: RequestError) => {
            Apm.captureError(err)
        })
}